import { render, staticRenderFns } from "./shpk.vue?vue&type=template&id=193d0aa2&scoped=true&"
import script from "./shpk.vue?vue&type=script&lang=js&"
export * from "./shpk.vue?vue&type=script&lang=js&"
import style0 from "./shpk.vue?vue&type=style&index=0&id=193d0aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d0aa2",
  null
  
)

export default component.exports